export default __webpack_public_path__ + "static/media/401_error.3713df10.svg";